export const formatDateString = (expiryDate) => {
  const options = { year: "numeric", month: "short", day: "2-digit" };
  return new Date(expiryDate).toLocaleDateString("en-US", options);
};
